import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { connect } from "dvajs";
import { Modal, Button, Select, message } from "antd";

function SanDingModal({
  sanding,
  changeSanding
}: {
  sanding: any;
  changeSanding: (info: any) => void;
}) {
  return (
    <Modal
      centered
      width="640px"
      style={{ height: 480, overflow: "hidden" }}
      bodyStyle={{ padding: "0 0 18px" }}
      title={sanding.title + "三定"}
      visible={sanding.visible}
      footer={null}
      onCancel={() => {
        changeSanding({ ...sanding, visible: false });
        setTimeout(() => {
          changeSanding({ visible: false, content: "", title: "" });
        }, 100);
      }}
    >
      <div className="sanding-wrap">
        <p>{sanding.content}</p>
      </div>
    </Modal>
  );
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps() {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(SanDingModal);
